import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { FormField } from '../../_shared/formfield/formfield.component';
import SubmissionHandler from '../../_shared/submissionhandler/submissionhandler';
import Header from '../../_shared/header/header';
import Footer from '../../_shared/footer/footer';
import flatten from '../../_shared/util/flatten';
import getTitles from '../../_shared/util/getTitles';
import { Helmet } from 'react-helmet';
import EmailLinkModal from '../../_shared/emaillink/emaillinkmodal.component';

@inject('livingRoomStore', 'routerStore', 'store', 'form', 'appStore')
@observer
export class WallsComponent extends Component {
    constructor(props) {
        super(props);
        this.emailModal = React.createRef();
    }

    onNext(e) {
        const { livingRoomStore, routerStore } = this.props,
            { history } = routerStore;

        history.push({ pathname: `/livingroom/${livingRoomStore.currentRoomNum}/floor`, state: { transition: 'forward' } });
    }

    onPrevious() {
        const { routerStore, store, form } = this.props,
            { history } = routerStore,
            dest = this.getPreviousLink();

        store.save(form.values(), false);
        history.push({ pathname: dest, state: { transition: 'back' } });
    }

    getPreviousLink() {
        const { livingRoomStore } = this.props;
        return livingRoomStore.currentRoomNum > 1
            ? `/livingroom/${livingRoomStore.currentRoomNum - 1}/ceiling` // level 2+ walls goes back to the previous level"s ceiling route
            : '/gettingstarted/floorarea'; // level 1 walls goes back to the floorarea route
    }

    render() {
        const { form, store, livingRoomStore, appStore } = this.props,
            errors = form.errors(),
            titles = getTitles(livingRoomStore.currentRoomNum, 'Wall details'),
            idPrefix = `walls-${livingRoomStore.currentRoomNum}`,
            prevActionName = livingRoomStore.currentRoomNum - 1 > 0 && livingRoomStore.currentRoomNum - 1 < livingRoomStore.numRooms
                ? `prev-${livingRoomStore.currentRoomNum}-walls-to-ceiling-${livingRoomStore.currentRoomNum - 1}`
                : `prev-${livingRoomStore.currentRoomNum}-walls-to-floorareadetails`,
            nextActionName = `next-${livingRoomStore.currentRoomNum}-walls-to-floor`,
            emailActionName = `email-${livingRoomStore.currentRoomNum}-walls`;

        return (
            <section className='ht-page ht-walls'>
                <Helmet>
                    <title>{titles.title} &raquo; {appStore.baseTitle}</title>
                </Helmet>
                <Header
                    titlePre={titles.titlePre}
                    title={titles.title}
                    idPrefix={idPrefix}
                    prevActionName={prevActionName}
                    emailActionName={emailActionName}
                    prev={{
                        onClick: () => this.onPrevious()
                    }}
                    email={{
                        modal: this.emailModal
                    }}
                />
                <SubmissionHandler store={store}>
                    {appStore.dataLoaded && (
                        <form className='ht-form'>
                            {form.map(field => {
                                field.errors = errors[field.path];

                                return (
                                    <FormField
                                        key={field.id}
                                        field={field}
                                        formValues={flatten(form.values())}
                                    />
                                );
                            })}
                            <Footer
                                idPrefix={idPrefix}
                                prevActionName={prevActionName}
                                nextActionName={nextActionName}
                                emailActionName={emailActionName}
                                next={{
                                    text: 'Go to floor details',
                                    loading: store.loading,
                                    disabled: !form.isValid || (store.error && store.error.code),
                                    onClick: e => form.onSubmit(e)
                                }}
                                prev={{
                                    onClick: () => this.onPrevious()
                                }}
                                email={{
                                    modal: this.emailModal
                                }}
                                showError={!form.isValid}
                                errorMessage={form.error}
                                emailProgressLinkSupText={window.HTContent.EmailProgressLinkSupText}
                            />
                        </form>
                    )}
                </SubmissionHandler>
                <EmailLinkModal ref={this.emailModal} />
            </section>
        );
    }
}
